import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import CompareCrmPricesWrapper from "@components/layouts/compareCrmPricesWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function InsureYourCarHome(): ReactElement {
    return (
        <CompareCrmPricesWrapper>
            <PrivacyPolicy category="Crm" domain="CompareCrmPrices.com" />
        </CompareCrmPricesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
